export default __webpack_public_path__ + "static/white-q-3ef24d709f61babf9cce910bfeef80cd.png";